import { UITextView, UIView, YES } from "uicore-ts"
import { RHButton } from "./RHButton"
import { RHButtons } from "./Utils_slop/RHDesignTokens"

export class RHTableActionButtonView extends UIView {

    preferredButtonWidth = RHButtons.tableActionWidth
    preferredButtonHeight = RHButtons.tableActionHeight
    
    readonly button = new RHButton().addedAsSubviewToView(this).configuredWithObject({
        titleLabel: {
            text: "Vaata",
            style: {
                whiteSpace: "nowrap",
                fontWeight: RHButtons.tableActionTitleFontWeight
            }
        },
        style: {
            fontSize: RHButtons.tableActionFontSize
        }
    })
    buttonWasPressed?: (sender: UIView, event: Event) => void
    
    constructor(elementID?: string) {
        super(elementID)
        
        this.button.variant = RHButtons.tableActionVariant
        this.button.contentPadding = RHButtons.tableActionContentPadding
        this.button.titleLabel.isSingleLine = YES
        this.button.titleLabel.textAlignment = UITextView.textAlignment.center
        // noinspection JSConstantReassignment
        this.button.controlEventTargetAccumulator.PrimaryActionTriggered = (sender: UIView, event: Event) => {
            this.buttonWasPressed?.(sender, event)
        }
    }
    
    set text(text: string) {
        this.button.titleLabel.text = text
    }
    
    get text(): string {
        return this.button.titleLabel.text
    }
    
    override layoutSubviews() {
        super.layoutSubviews()

        // Cap the button to the cell width. The column is proportional, so on
        // narrow tables the cell can become narrower than preferredButtonWidth;
        // a fixed-width centered button would then overflow the cell to the
        // right, past the card's edge. Shrinking it to fit keeps it inside.
        const buttonWidth = Math.min(this.preferredButtonWidth, this.bounds.width)

        this.button.frame = this.bounds
            .rectangleWithWidth(buttonWidth, 0.5)
            .rectangleWithHeight(this.preferredButtonHeight, 0.5)
    }
    
    override intrinsicContentHeight(constrainingWidth = 0) {
        return this.preferredButtonHeight
    }
    
}
